import { useEnquiryForm, Honeypot } from '../components/Form.jsx';

/**
 * The newsletter signup, used in-page rather than as its own route.
 */
export default function Subscribe() {
  const { submit, error, sending, done } = useEnquiryForm('subscribe');

  if (done) {
    return (
      <div className="subscribe" role="status">
        <p className="eyebrow">You're on the list</p>
        <p className="dim" style={{ margin: 0 }}>
          The Cyber Brief goes out weekly. Unsubscribe is one click, at the bottom of every issue.
        </p>
      </div>
    );
  }

  return (
    <form className="subscribe" onSubmit={submit}>
      <div>
        <p className="eyebrow">Stay ahead of the threat landscape</p>
        <p className="dim" style={{ margin: 0, maxWidth: '30rem' }}>
          Cybersecurity insights, tech news, and Ennoveda updates, weekly.
        </p>
      </div>
      <div className="subscribe-row">
        <Honeypot />
        <label className="sr-only" htmlFor="sub-email">Email address</label>
        <input id="sub-email" name="email" type="email" required placeholder="you@company.com" autoComplete="email" />
        <button type="submit" className="btn btn-primary" disabled={sending}>
          {sending ? 'Signing up…' : 'Subscribe'}
        </button>
      </div>
      {error && <p className="check-error" role="alert" style={{ gridColumn: '1 / -1' }}>{error}</p>}
    </form>
  );
}
